export default __webpack_public_path__ + "static/media/Mo_Akins_AHV_In_Moms_We_Trust.4190af99.jpg";